import { PageComponent } from '@root/pages/Type';
import { RootState } from '@root/store/types';
import { useSelector } from 'react-redux';
import { ServicesState } from '@root/store/services';
import _ from 'lodash';
import Item from './Item';
import ItemSkeleton from './ItemSkeleton';
import styles from './style.module.scss';
import { useMemo } from 'react';

const List: PageComponent = () => {
    const { data, isRequesting, error } = useSelector<RootState, ServicesState>(
        (state) => state.services,
    );

    const sortedData = useMemo(() => {
        return _.orderBy(data, (service) => service.orderNo, 'desc');
    }, [data]);

    if (isRequesting) {
        return (
            <div className={styles.service_list}>
                {Array(3).map((_, placeholderIndex) => (
                    <ItemSkeleton
                        key={`server-skeleton-${placeholderIndex}`}
                        index={placeholderIndex.toString()}
                    />
                ))}
            </div>
        );
    }

    if (error) {
        return <>Error: {error}</>;
    }

    return (
        <div className={styles.service_list}>
            {_.map(sortedData, (service) => (
                <Item key={`server-${service.orderNo}`} service={service} />
            ))}
        </div>
    );
};

export default List;
